export default __webpack_public_path__ + "images/272fd34bc8c628321e023f8c14c16592-no-results--light.svg";